import config from '../config/oauth2'

const getUrl = (): string => {
  return `https://${config.domainName}?&client_id=${config.clientID}&response_type=token&redirect_uri=${config.redirectURI}&state=${(new Date()).getTime()}&scope=openid%20profile`
}

interface TokenData {
  idToken: string
  accessToken: string
}
interface TokenDataHash {
  id_token: string
  access_token: string
}

export const getTokenData = (hash: string): TokenData => {
  const hashObject = <TokenDataHash> hash
    .substr(1, hash.length)
    .split('&')
    .map(v => v.split('='))
    .reduce((pre, [key, value]) => ({ ...pre, [key]: value }), {})

  return { idToken: hashObject.id_token || hashObject.access_token, accessToken: hashObject.access_token }
}

export const login = (): void => {
  window.location.replace(getUrl())
}
